// extracted by mini-css-extract-plugin
module.exports = {"wrap":"oj","contentWrapCtaDefault":"pj","disabled":"qj","contentWrapCtaWhite":"rj","promos":"sj","lazyPromo":"tj","mainContent":"uj","headingText":"vj","copy":"wj","subtext":"xj"};